export type Location = { latitude: number; longitude: number };

const getCurrentLocation = (geoLocation: any) =>
  new Promise((resolve, reject) => {
    const options = {
      enableHighAccuracy: false,
      timeout: 20000,
      maximumAge: 0,
    };
    geoLocation.getCurrentPosition(resolve, reject, options);
  });

export const checkGeoLocationPermissions = (
  onApproved: () => void,
  onDenied: () => void,
  windowNavigator = window.navigator
) => {
  if (windowNavigator.permissions?.query) {
    return windowNavigator.permissions
      .query({ name: 'geolocation' })
      .then((result) => {
        if (result.state === 'denied') {
          onDenied();
        } else {
          onApproved();
        }
        const response = result;
        response.onchange = () =>
          checkGeoLocationPermissions(onApproved, onDenied);

        return Promise.resolve();
      });
  }
  return Promise.reject();
};

export const geoLocationPrompt = (
  onGeoLocationSuccess: any,
  onGeoLocationError: any,
  windowNavigator = window.navigator
) => {
  const currentLocation = getCurrentLocation(windowNavigator.geolocation);

  return currentLocation
    .then((result: any) => {
      onGeoLocationSuccess(result);
      return Promise.resolve();
    })
    .catch((result: any) => {
      onGeoLocationError(result);
      return Promise.reject();
    });
};
